import { render, staticRenderFns } from "./issued.vue?vue&type=template&id=ed506324"
import script from "./issued.vue?vue&type=script&lang=js"
export * from "./issued.vue?vue&type=script&lang=js"
import style0 from "./issued.vue?vue&type=style&index=0&id=ed506324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports